import type { OriginalCompatCommitAudit, OriginalCompatProjectOpenAudit } from './compatTypes';

export function logOriginalCompatProjectOpen(audit: OriginalCompatProjectOpenAudit): void {
  console.log(`[ORIGINAL COMPAT PROJECT OPEN] ${JSON.stringify(audit)}`);
}

export function logOriginalCompatCommit(audit: OriginalCompatCommitAudit): void {
  console.log(`[ORIGINAL COMPAT COMMIT] ${JSON.stringify(audit)}`);
}
